import ImmutablePropTypes from 'react-immutable-proptypes'
import { useDrag, useDrop } from 'react-dnd'
import React from 'react'
import PropTypes from 'prop-types'
import _get from 'lodash/get'
import { ICON_TYPES } from '../../Icon.v2/index'
import { DRAGGABLE_TYPE } from '../../../services/portal/index'
import Button, { TYPES } from '../../Button/index'

function getClassName (isDragging, isOver) {
  const base = 'portal-playlist-v2-edit__playlist-item-wrapper'
  const cls = [base]
  if (isDragging) {
    cls.push(`${base}--dragging`)
  }
  if (isOver) {
    cls.push(`${base}--is-over`)
  }
  return cls.join(' ')
}

const PlaylistItem = ({
  onRemoveItem,
  playlistItem,
  onReorder,
  id,
}) => {
  const [{ isDragging }, drag] = useDrag({
    item: {
      type: DRAGGABLE_TYPE.PLAYLIST_ITEM,
      id,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const [{ isOver }, drop] = useDrop({
    accept: DRAGGABLE_TYPE.PLAYLIST_ITEM,
    drop (item) {
      onReorder(_get(item, 'id'), playlistItem.get('playlistPosition'))
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
  })

  return (
    <div
      ref={drop}
      className={getClassName(isDragging, isOver)}
    >
      <div className="portal-playlist-v2-edit__playlist-item">
        <img
          ref={drag}
          className="portal-playlist-v2-edit__playlist-item-img"
          alt={playlistItem.get('title')}
          src={playlistItem.get('imageWithText')}
        />
        <Button
          className="portal-playlist-v2__playlist-item-action-btn"
          onClick={() => onRemoveItem(id)}
          type={TYPES.ICON_PRIMARY}
          icon={ICON_TYPES.CLOSE}
          shadow
        />
      </div>
    </div>
  )
}

PlaylistItem.propTypes = {
  playlistItem: ImmutablePropTypes.map.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
}

export default PlaylistItem
